import React from "react";
import { Link } from "react-router-dom";

export const Header = () => {
  return (
    <div className="top-header position-sticky sticky-top">
      <nav className="navbar navbar-light bg-white navbar-expand-md py-3 shadow-sm" data-bs-theme="light" style={{ minHeight: "70px" }}>
        <div className="container-xl">
          {/* Logo */}
          <Link className="navbar-brand logo-wrapper text-center p-0" to={"/"}>
            <img src={require("../assets/images/logo.png")} alt="Logo" className="img-fluid" />
          </Link>

          {/* Desktop Navigation */}
          <div className="d-none d-md-flex align-items-center">
            <ul className="navbar-nav menu-link-nav align-items-center flex-row gap-4">
              <li className="nav-item">
                <Link to={'/'} className="nav-link text-dark fw-medium">Home</Link>
              </li>
              <li className="nav-item">
                <Link to={'/about'} className="nav-link text-dark fw-medium">About</Link>
              </li>
              <li className="nav-item">
                <Link to={'/features'} className="nav-link text-dark fw-medium">Features</Link>
              </li>
              <li className="nav-item">
                <Link to={'/pricing'} className="nav-link text-dark fw-medium">Pricing</Link>
              </li>
              <li className="nav-item">
                <Link to={'/contact'} className="nav-link text-dark fw-medium">Contact</Link>
              </li>
            </ul>
            
            {/* Right side buttons */}
            <div className="d-flex align-items-center gap-3 ms-4">
              <Link to={'/login'} className="btn btn-outline-primary px-4 py-2 rounded-pill fw-medium">
                Login
              </Link>
              <Link to={'/signup'} className="btn btn-primary px-4 py-2 rounded-pill fw-medium">
                Sign Up
              </Link>
            </div>
          </div>

          {/* Mobile toggle */}
          <button className="navbar-toggler border-0 shadow-none d-md-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasTopHeader" aria-controls="offcanvasTopHeader">
            <i className="bi bi-list fs-3 text-dark"></i>
          </button>

          {/* Mobile Offcanvas menu */}
          <div className="offcanvas offcanvas-end border-0" tabIndex="-1" id="offcanvasTopHeader" aria-labelledby="offcanvasTopHeaderLabel">
            <div className="offcanvas-header bg-white border-bottom">
              <h5 className="offcanvas-title text-dark fw-bold">Menu</h5>
              <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>

            {/* <div className="offcanvas-body bg-white">
              <ul className="navbar-nav menu-link-nav flex-column gap-3">
                <li className="nav-item">
                  <Link to={'/'} className="nav-link text-dark fw-medium fs-5">Home</Link>
                </li>
                <li className="nav-item">
                  <Link to={'/about'} className="nav-link text-dark fw-medium fs-5">About</Link>
                </li>
                <li className="nav-item">
                  <Link to={'/features'} className="nav-link text-dark fw-medium fs-5">Features</Link>
                </li>
                <li className="nav-item">
                  <Link to={'/pricing'} className="nav-link text-dark fw-medium fs-5">Pricing</Link>
                </li>
                <li className="nav-item">
                  <Link to={'/contact'} className="nav-link text-dark fw-medium fs-5">Contact</Link>
                </li>
              </ul>
              <div className="mt-4 d-flex flex-column gap-3">
                <Link to={'/login'} className="btn btn-outline-primary px-4 py-2 rounded-pill fw-medium">
                  Login
                </Link>
                <Link to={'/signup'} className="btn btn-primary px-4 py-2 rounded-pill fw-medium">
                  Sign Up
                </Link>
              </div>
            </div> */}
          </div>
        </div>
      </nav>
    </div>
  );
};
